import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";
import { generosPersona, TITULO_DOC_REG } from "../../../utils/constantes";
import { getAllPaises } from "../../../services/pais.service";
import { getAllDepartamentosByIdPais } from "../../../services/departamento.service";
import { crearDocente } from "../../../services/docente.service";
import { crearPersona } from "../../../services/persona.service";
import { getAllIdiomas } from "../../../services/idioma.service";
import { crearDocenteIdioma } from "../../../services/docenteIdioma.service";
import { FormHook } from "../../../components/molecules/FormHook";
import { FormDiv } from "../../../components/atoms/FormDiv";
import { FormInput } from "../../../components/molecules/FormInput";
import { FormSelect } from "../../../components/atoms/FormSelect";
import { showAlert, showErrorAlert } from "../../../components/molecules/ShowAlert";
import { SubmitButton } from "../../../components/atoms/SubmitButton";
export const RegistrarDocentePage = () => {
  const [idiomasSeleccionados, setIdiomasSeleccionados] = useState([]);
  const [generos, setGeneros] = useState(generosPersona);
  const [idiomas, setIdiomas] = useState([]);
  const [paises, setPaises] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [cv, setCv] = useState(null);
  const [estaCargando, setEstaCargando] = useState(false);
  const DIR_ICONO_DOC = "img/iconos/titulo de docente (con la pizarra).svg";

  const navigate = useNavigate();
  const {
    handleSubmit,
    register,
    control,
    formState: { errors }
  } = useForm();

  const obtenerPaises = async () => {
    await getAllPaises().then((paises) => {
      setPaises(paises?.map((pais) => ({
        value: pais?.idPais,
        label: pais?.nombre,
      })));
    }).catch((err) => console.log(err));
  };

  const handleGetDepartamentosByIdPais = async (data) => {
    await getAllDepartamentosByIdPais(data.value)
      .then((departamentos) =>
        setDepartamentos(departamentos?.map((departamento) => ({
          value: departamento?.idDepartamento,
          label: departamento?.nombre,
        })))
      )
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    obtenerPaises();
    obtenerIdiomas();
  }, []);

  const handleIdiomasChange = (selected) => {
    setIdiomasSeleccionados(selected);
  };

  const obtenerIdiomas = async () => {
    await getAllIdiomas()
      .then((idiomas) => {
        setIdiomas(idiomas?.map((idioma) => ({
          value: idioma?.idIdioma,
          label: idioma?.nombre,
        })));
      })
      .catch((err) => console.log(err));
  };

  const handleFileCVChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        setCv(base64String);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  const submit = async (data) => {
    setEstaCargando(true);
    console.log("data: ", data)
    const dataPersona = {
      nombre: data.nombre,
      apellido: data.apellido,
      celular: data.celular,
      correo: data.correo,
      ci: data.ci,
      fechaNacimiento: data.fechaNacimiento,
      idDepartamento: data.idDepartamento?.value,
      sexo: data.sexo.value,
      anioAdmision: data.anioAdmision,
    };
    try {
      const nuevaPersona = await crearPersona(dataPersona);
      const dataDocente = {
        idPersona: nuevaPersona?.persona.idPersona,
        cv: cv,
      };
      const nuevoDocente = await crearDocente(dataDocente);
      const idiomaPromises = idiomasSeleccionados.map((idioma) =>
        crearDocenteIdioma({
          idDocente: nuevoDocente.idDocente,
          idIdioma: idioma.value,
        })
      );
      await Promise.all(idiomaPromises);
      showAlert({
        text: `Nuevo docente con código: ${nuevaPersona?.usuario?.username}.`,
        callback: () => {
          navigate("/docentes");
        },
      });
    } catch (err) {
      const errorMessage = err.response.data.message;
      showErrorAlert({ text: errorMessage })
    } finally {
      setEstaCargando(false);
    }
  };

  return (
    <ContenedorPageTemplate dirIcono={DIR_ICONO_DOC} titulo={TITULO_DOC_REG}>
      <FormHook handleSubmit={handleSubmit} submit={submit}>
        <FormDiv className="md:flex flex-wrap">
          <FormInput
            id="nombre"
            label="Nombre"
            type="text"
            placeholder="Nombre"
            register={register}
            validation={{
              required: { value: true, message: "Campo requerido" },
              maxLength: { value: 40, message: "Súpero la cantidad máxima  40 caracteres" },
              minLength: { value: 1, message: "Mínimo 1 caracter" },
            }}
            error={errors.nombre}
            className="md:w-1/2 md:pr-2"
          />

          <FormInput
            id="apellido"
            label="Apellido"
            type="text"
            placeholder="Apellido"
            register={register}
            validation={{
              required: { value: true, message: "Campo requerido" },
              maxLength: { value: 50, message: "Súpero la cantidad máxima 50 caracteres" },
              minLength: { value: 1, message: "Mínimo 1 caracter" },
            }}
            error={errors.apellido}
            className="md:w-1/2 md:pr-2"
          />
          <FormInput
            id="ci"
            label="Cédula de identidad"
            type="text"
            placeholder="Cédula  de identidad"
            register={register}
            validation={{
              maxLength: { value: 15, message: "Súpero la cantidad máxima 15 caracteres" },
              minLength: { value: 3, message: "Mínimo 3 caracteres" }
            }}
            error={errors.ci}
            className="md:w-1/2 md:pl-2"
          />

          <FormInput
            id="celular"
            label="Número teléfono "
            type="text"
            placeholder="Número teléfono"
            register={register}
            validation={{
              required: { value: true, message: "Campo requerido" },
              maxLength: { value: 15, message: "Súpero la cantidad máxima  15 caracteres" },
              minLength: { value: 6, message: "Mínimo 6 caracteres" },
            }}
            error={errors.celular}
            className="md:w-1/2 md:pr-2"
          />
          <FormInput
            id="correo"
            label="Correo"
            type="text"
            placeholder="Correo electronico"
            register={register}
            validation={{
              required: { value: true, message: "Campo requerido", },
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, message: 'Correo invalido, (caracteres necesarios "@, .com")'
              },
              maxLength: { value: 100, message: "Súpero la cantidad máxima 100 caracteres" },
              minLength: { value: 5, message: "Mínimo 5 caracter" },
            }}
            error={errors.correo}
            className="md:w-full"
          />
          <FormInput
            id="fechaNacimiento"
            label="Fecha de Nacimiento"
            type="date"
            register={register}
            validation={{ required: { value: true, message: "Campo requerido" } }}
            error={errors.fechaNacimiento}
            className="md:w-1/2 md:pr-2"
          />
          <FormInput
            id="anioAdmision"
            label="Fecha de ingreso"
            type="date"
            register={register}
            validation={{ required: { value: true, message: "Campo requerido", } }}
            error={errors.anioAdmision}
            className="md:w-1/2 md:pl-2"
          />
        </FormDiv>
        <FormDiv className="md:flex">
          <FormSelect
            name="pais"
            label="Pais"
            control={control}
            options={paises}
            isMulti={false}
            validation={{ required: "Campo requerido" }}
            placeholder="Seleccione un pais"
            handleChange={handleGetDepartamentosByIdPais}
            error={errors.pais}
            className="md:w-1/2 md:pr-2"
          />
          <FormSelect
            name="idDepartamento"
            label="Departamento"
            control={control}
            options={departamentos}
            isMulti={false}
            validation={{ required: "Campo requerido" }}
            placeholder="Seleccione un departamento"
            error={errors.idDepartamento}
            className="md:w-1/2 md:px-2"
          />
          <FormSelect
            name="sexo"
            label="Género"
            control={control}
            options={generos}
            isMulti={false}
            validation={{ required: "Campo requerido" }}
            placeholder="Seleccione un género"
            error={errors.sexo}
            className="md:w-1/2 md:pl-2"
          />
        </FormDiv>
        <FormDiv className="md:flex">
          <FormSelect
            name="idiomas"
            label="Idiomas"
            control={control}
            options={idiomas}
            isMulti={true}
            validation={{ required: "Campo requerido" }}
            placeholder="Idiomas"
            handleChange={handleIdiomasChange}
            error={errors.idiomas}
            className="md:w-1/2 md:pr-2"
          />
          <FormInput
            id="cv"
            label="Subir C.V."
            type="file"
            placeholder="cv"
            register={register}
            onChange={handleFileCVChange}
            className="md:w-1/2 md:pl-2"
            classNameInput="py-2"
          />
        </FormDiv>
        <SubmitButton estaCargando={estaCargando} />
      </FormHook>
    </ContenedorPageTemplate>
  );
};
